<template>
    <div class="footer">
        <b-container class="footer-content">
            <b-container>
            <b-row>
                <b-col cols="12" md="3" class="mb-4">
                    <div>
                        <b-link to="/"><h2>Our Rainbow</h2></b-link>
                    </div>
                </b-col>
                <b-col cols="12" md="5" class="content-categories mb-4">
                    <b-row >
                        <b-col v-for="(cat, index) in categories" :key="cat.id" cols="6">
                            <div v-if="index < 3">
                                <b-link :to="'/' + cat.name">{{cat.name}}</b-link>
                            </div>
                            <div v-if="index >= 3">
                                <b-link :to="'/' + cat.name">{{cat.name}}</b-link>
                            </div>
                        </b-col>
                    </b-row>                                 
                </b-col>
                <b-col cols="12" md="4">
                    <p>Mỗi cá nhân khi sinh ra và lớn lên đều quyền bình đẳng. Kể cả bạn có là ai đi chăng nữa thì đều được
                         hưởng quyền được sống, quyền được tự do, quyền được yêu, quyền được mưu cầu hạnh phúc... 
                    </p>
                </b-col>
            </b-row>
            </b-container>
        </b-container>
        <div class="copywright">
            <p> ©2020 Our Rainbow</p>
        </div>
    </div>
</template>

<script>
import  { store }  from '../../firebase/categories'

export default {
    data() {
        return {
            store: store,
        }
    },
    computed: {
        categories () { 
            return this.store.categories 
        },
    },
}
</script>

<style scoped lang="scss">
    @import '../../styles/components/navigation/Footer.scss'
</style>